// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.url-modal .img-size input {
  font-size: 12px;
}
.url-modal .img-lock {
  position: absolute;
  top: calc(50% - 20px);
  left: calc(50% + 12px);
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/Editor/src/components/UploadUrlModal/index.less"],"names":[],"mappings":"AAAA;EAGY,eAAA;AADZ;AAFA;EAQQ,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AAHR","sourcesContent":[".url-modal {\n    .img-size {\n        input {\n            font-size: 12px;\n        }\n    }\n\n    .img-lock {\n        position: absolute;\n        top: calc(50% - 20px);\n        left: calc(50% + 12px);\n        cursor: not-allowed;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
